import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { LocalDate } from '../../../core/model/local-date';
import { ChartDefinition, ChartDefinitionFactory } from '../../../core/service/factory/chart-definition-factory.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MeterMediaType, getMediaTypeUnitText } from '../../model/const/enums';
import { ConsumptionDay } from '../../model/consumption-day';
import { ConsumptionDayService } from '../../service/consumption-day.service';

@Component({
    selector: 'app-period-consumption',
    templateUrl: './period-consumption.component.html',
    styleUrls: ['./period-consumption.component.scss'],
    providers: [ConsumptionDayService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PeriodConsumptionComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: ConsumptionDayService,
    private _fcf: FormControlExFactory,
    private _chartDefinitionFactory: ChartDefinitionFactory,
    private _cdf: ColumnDefinitionFactory
  ) {
    this.columnDefinition = [
      this._cdf.createDate('COMMON.DAY', 'consumptionDate', ColumnVisibility.mandatory),
      this._cdf.createNumber('CONSUMPTION.CONSUMPTION', 'consumption', { visibility: ColumnVisibility.mandatory, totalSum: true }),
      this._cdf.createMoney('COMMON.AMOUNT', 'cost', ColumnVisibility.default),
      this._cdf.createMoney('CONSUMPTION.PRICELIST.PRICE_PER_UNIT', 'pricePerUnit', {
        visibility: ColumnVisibility.optional,
        totalSum: false,
      }),
    ];
  }

  itemsSource: ConsumptionDay[];
  private _loadSub: Subscription;
  @Input() meterId: string;
  @Input() propertyId: string;
  @Input() meterType: MeterMediaType;

  private _fromDate: LocalDate;
  @Input() set fromDate(value: LocalDate) {
    this._fromDate = value;
  }

  private _toDate: LocalDate;
  @Input() set toDate(value: LocalDate) {
    this._toDate = value;
    this.updateChart();
  }

  columnDefinition: ColumnDefinition[];

  ngOnDestroy(): void {
    if (this._loadSub) {
      this._loadSub.unsubscribe();
    }
  }

  chartDefinition: ChartDefinition;

  private updateChart() {
    if (!this.meterType) {
      return;
    }
    switch (this.meterType) {
      case MeterMediaType.ColdWater:
        this.mediaTypeText = 'CONSUMPTION.MEDIA_TYPE.TYPES.COLD_WATER';
        break;
      case MeterMediaType.Electricity:
        this.mediaTypeText = 'CONSUMPTION.MEDIA_TYPE.TYPES.ELECTRICITY';
        break;
      case MeterMediaType.WarmWater:
        this.mediaTypeText = 'CONSUMPTION.MEDIA_TYPE.TYPES.HOT_WATER';
        break;
      case MeterMediaType.Heating:
        this.mediaTypeText = 'CONSUMPTION.MEDIA_TYPE.TYPES.HEATING';
        break;
    }
    if (!this._fromDate || !this._toDate) {
      return;
    }
    if (!this.meterId && !this.propertyId) {
      return;
    }
    if (this._loadSub) {
      this._loadSub.unsubscribe();
    }
    this.message = 'COMMON.LOADING_MSG';
    if (this.meterId) {
      this._loadSub = this._dataService.getMeterValues(this.meterId, this._fromDate, this._toDate).subscribe(val => {
        this.onDataLoaded(val);
      });
    } else {
      this._loadSub = this._dataService.getPropertyValues(this.propertyId, this._fromDate, this._toDate, this.meterType).subscribe(val => {
        this.onDataLoaded(val);
      });
    }
  }

  mediaTypeText: string;
  message: string;

  onDataLoaded(data: ConsumptionDay[]) {
    this.itemsSource = data;
    this.chartDefinition = this._chartDefinitionFactory.create(
      'CONSUMPTION.CONSUMPTION',
      [{ name: getMediaTypeUnitText(this.meterType), data: data.map(v => v.consumption) }],
      data.map(v => LocalDate.fromDate(v.consumptionDate).toISOString()),
      'area',
      300
    );
    this.message = data.length == 0 ? 'COMMON.NO_DATA' : null;
  }

  ngOnInit() {
    if (!this._fromDate) {
      let from = LocalDate.fromDate(LocalDate.today().addMonths(-2));
      from.day = 1;
      this.fromDate = from;
    }
    if (!this.toDate) {
      this.toDate = LocalDate.today();
    }
  }
}
